import React, {useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import {formatMoney} from '@shopify/theme-currency';

import {imageUrl} from '../../../../assets/scripts/utils/shopify-images';
import iconPlus from '../../../../assets/svg/icon-plus.svg';
import iconMinus from '../../../../assets/svg/icon-minus.svg';
import Slider from '../../slider/Slider';

/* eslint-disable babel/camelcase */
const CartUpsells = ({total, products, addToCart}) => {
  const upsellsHeading = window.theme.cartUpsells ? window.theme.cartUpsells.heading : '';
  const upsellsAddToCart = window.theme.strings.addToCart ? window.theme.strings.addToCart : 'Add to Bag';
  const [upsellsExpanded, setUpsellsExpanded] = useState(false);
  const upsellsCollapseWrapper = useRef(null);

  const addUpsellProductToCart = async (variantId) => {
    if (!variantId) {
      return;
    }

    const item = {
      id: variantId,
      quantity: 1,
      properties: {
        _cart_upsell: true,
      },
    };
    await addToCart(item, false);
  };

  let slidesId = '';
  const upsellSlides = products.map(({variants, title, featured_image, price, id, handle, url}) => {
    slidesId += `${id}`;
    const firstAvailableVariant = variants.find((variant) => variant.available === true);
    const featured_image_url =
      featured_image.includes('https') || featured_image.includes('http') ? featured_image : `https:${featured_image}`;
    return (
      <div key={id} className="side-cart__upsell-item">
        {featured_image && (
          <div className="side-cart__upsell-image">
            <a href={`/products/${handle}`} className="side-cart__upsell-image--wrapper">
              <img
                src={imageUrl(featured_image_url, 340, 227, 'center')}
                width={340}
                height={227}
                alt={title}
                loading="lazy"
              />
            </a>
          </div>
        )}
        <div className="side-cart__upsell-info">
          <p className="side-cart__upsell-title h8">{title}</p>
          <p
            className="side-cart__upsell-price text-small"
            dangerouslySetInnerHTML={{
              __html: formatMoney(price, window.theme.moneyFormat),
            }}
          />
          {variants.length > 1 ? (
            <a href={url} className="btn btn--text-underline">
              {window.theme.cartUpsells.viewDetail}
            </a>
          ) : (
            <button
              type="button"
              className="btn btn--secondary btn--block"
              onClick={() => addUpsellProductToCart(firstAvailableVariant.id)}
            >
              <span dangerouslySetInnerHTML={{__html: upsellsAddToCart}} />
            </button>
          )}
        </div>
      </div>
    );
  });

  const handleUpsellToggle = (event) => {
    if (event) {
      event.preventDefault();
    }
    if (upsellsCollapseWrapper.current) {
      if (upsellsExpanded) {
        upsellsCollapseWrapper.current.style.height = 0;
      } else {
        upsellsCollapseWrapper.current.style.height = `${upsellsCollapseWrapper.current.scrollHeight}px`;
      }
    }
    setUpsellsExpanded(!upsellsExpanded);
  };

  useEffect(() => {
    if (!upsellsExpanded) return;

    const sideCartDrawer = document.querySelector('.side-cart');
    if (!sideCartDrawer) return;

    upsellsCollapseWrapper.current.addEventListener('transitionend', () => {
      sideCartDrawer.scrollTo({
        top: sideCartDrawer.scrollHeight,
        behavior: 'smooth',
      });
    });
  }, [upsellsExpanded]);

  return (
    <>
      {total > 0 && (
        <div className={`side-cart__upsells ${upsellsExpanded ? 'is-expanded' : ''}`}>
          <button
            type="button"
            className="side-cart__upsells-toggle btn-none btn--block h9"
            onClick={handleUpsellToggle}
          >
            {upsellsHeading}
            {upsellsExpanded ? (
              <span dangerouslySetInnerHTML={{__html: iconMinus}} />
            ) : (
              <span dangerouslySetInnerHTML={{__html: iconPlus}} />
            )}
          </button>
          <div className="side-cart__upsell-items" ref={upsellsCollapseWrapper}>
            <Slider
              slidesId={slidesId}
              flickityConfig={{
                cellAlign: 'left',
                draggable: upsellSlides.length > 1,
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                watchCSS: true,
              }}
              classPrefix="upsells"
            >
              {upsellSlides}
            </Slider>
          </div>
        </div>
      )}
    </>
  );
};
/* eslint-enable babel/camelcase */

/* eslint-disable react/forbid-prop-types */
CartUpsells.propTypes = {
  total: PropTypes.number,
  products: PropTypes.array,
  addToCart: PropTypes.func,
};
/* eslint-enable react/forbid-prop-types */

export default CartUpsells;
